import { Ref, useEffect, useRef } from 'react';
import { useCreatePipelineContext } from '../../hooks/useCreatePipelineContext';
import { ObjectsConfig } from '../../../ObjectsConfiguration/components/ObjectsConfig/ObjectsConfig';
import { useAnalyticsTracker } from '../../../../tracking/hooks/useAnalyticsTracker';
import { CreatePipelineTrackers } from '../../../tracking/create-pipeline-trackers';
import { FlatFileObjectConfig } from '../../../ObjectsConfiguration/components/FlatFileObjectsConfig/FlatFileObjectConfig';
import {
  ObjectsConfigImperativeRefState,
  ObjectsConfigInnerState
} from '../../../ObjectsConfiguration/components/interfaces/object-config';
import { WizardStepBaseProps } from '../../../../wizard/interfaces/wizard-step-base-props';
import { UpgradePipelineBanner } from '../../../UpgradePipeline/UpgradePipelineBanner';

export function CreatePipelineConfigureObjects({
  updateWizardStepFooterProps,
  completeStep
}: WizardStepBaseProps) {
  const { pipeline, standardPipelineInfo, isUpgradingPipeline } = useCreatePipelineContext();
  const { eventTrack } = useAnalyticsTracker();

  const formRef = useRef<ObjectsConfigImperativeRefState>();

  useEffect(() => {
    return () => {
      updateWizardStepFooterProps({});
    };
  }, []);

  if (!pipeline) {
    return null;
  }

  const renderFlatFileObjectsConfig =
    pipeline.source!.sourceType.properties!.flatFileObjectSelectEnabled;

  const navigateToReview = () => {
    eventTrack({
      action:
        CreatePipelineTrackers.PIPELINE_TRACKER_CREATE_PIPELINE_OBJECT_CONFIG_SAVED_CONFIGURATION,
      properties: {
        pipelineId: pipeline.id
      }
    });

    completeStep();
  };

  const onObjectConfigInnerStateUpdate = (state: ObjectsConfigInnerState) => {
    updateWizardStepFooterProps({
      onClick: () => formRef.current?.submitForm(),
      showProgress: state.savingForm,
      disabled: state.disabled,
      children: 'Save & Continue'
    });
  };

  return (
    <div className='flex-col h-100 overflow-auto'>
      {isUpgradingPipeline ? (
        <UpgradePipelineBanner
          className='mb-0'
          standardPipelineInfo={standardPipelineInfo}
          isObjectConfigPage
        />
      ) : null}

      <div className='flex-1'>
        {renderFlatFileObjectsConfig ? (
          <FlatFileObjectConfig
            onSave={navigateToReview}
            pipeline={pipeline}
            onStateUpdate={onObjectConfigInnerStateUpdate}
            formImperativeRef={formRef as unknown as Ref<ObjectsConfigImperativeRefState>}
          />
        ) : (
          <ObjectsConfig
            isViewMode={false}
            integration={pipeline}
            onSave={navigateToReview}
            onStateUpdate={onObjectConfigInnerStateUpdate}
            formImperativeRef={formRef as unknown as Ref<ObjectsConfigImperativeRefState>}
          />
        )}
      </div>
    </div>
  );
}
